import { useState, useEffect, useRef } from "react";
import { makeStyles, withStyles } from '@material-ui/core';
import ReactPlayer from 'react-player'
import screenfull from 'screenfull'
import Slider from "@material-ui/core/Slider";
import { useDispatch, useSelector } from "react-redux";
import { VideoLoading } from "../../../../../../atoms/commonLoadings";
import apiConfigs from "../../../../../../../config/config";
import { updateOnBoardingSettings } from "../../../../../../../store/actions/creator/creatorOnBoarding";

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    zIndex: 1000
  },
  container: {
    position: 'relative',
    justifyContent: 'center',
    display: 'flex',
    zIndex: 1001,
    boxShadow: '0px 0px 6px #00000086',
    borderRadius: 10,
    margin: 'auto'
  },
  box: {
    background: '#000',
    width: '100%',
    height: '100%',
    borderRadius: 6,
    overflow: 'hidden',
    display: 'none'
  },
  player: {
    borderRadius: 12,
  },
  control: {
    position: 'absolute',
    bottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: -20,
    marginLeft: 1,
    marginRight: 6,
    zIndex: 10,
  },
  progress: {
    width: '100%',
    marginLeft: -1,
    marginTop: -3
  },
  playBtn: {
    width: 32,
    height: 14,
    borderRadius: 4,
    cursor: 'pointer',
    marginRight: 2,
    marginLeft: 7,
    marginBottom: 2,
  },
  video: {
    borderRadius: 10,
    background: '#11151C',
    objectFit: 'cover'
  },
  playback: {
    width: 100,
    height: 100,
    borderRadius: 50,
    position: 'absolute',
    display: 'flex',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#000',
    opacity: 0.5,
    zIndex: 1000,
    cursor: 'pointer'
  },
  playbackIcon: {
    width: 50,
    height: 50
  },
}));

const PrettoSlider = withStyles({
  root: {
    color: '#00ABF1',
    height: 8,
    padding: '1px 0!important'
  },
  thumb: {
    display: 'none!important'
  },
  active: {},
  track: {
    height: 10,
    borderRadius: 2
  },
  rail: {
    color: '#1F2625',
    height: 10,
    borderRadius: 2,
    border: '1px solid #666666'
  },
})(Slider);

function VideoSection(props: any) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const playerRef: any = useRef(null);
  const {
    mt, mb, width, height, video, videoStart, videoEnd,
    popOut, img, position, graphLength, isMobile, onVideoPlay
  } = props;
  const [playing, setPlaying] = useState(false);
  const [played, setPlayed] = useState(0);
  const [ended, setEnded] = useState(false);
  const [duration, setDuration] = useState(1);
  const [seeking, setSeeking] = useState(false);
  const [hoverState, setHoverState] = useState(false);
  const [videoLoading, setVideoLoading] = useState(false);
  const [videoReady, setVideoReady] = useState(false);
  const [videoAvailable, setVideoAvailable] = useState(false);
  const { userPreferences, module4Settings } = useSelector((state: any) => state.creatorOnBoarding);
  const { module4Data } = userPreferences;
  const { analyze } = module4Data.value;
  const { videoPopIn, videoSkip, clickedPillsTime } = module4Settings;

  const stimulus = analyze?.stimulus;

  useEffect(() => {
    const stimulusLength = stimulus?.stimulus_video_length ? Number(stimulus.stimulus_video_length) : duration;
    let videoPosition = videoPopIn / stimulusLength;

    if (!playerRef?.current || stimulusLength === 1) return;
    if (!videoPosition) videoPosition = 0;

    setVideoAvailable(true);
    if (!videoAvailable) return;

    if (videoPosition > 1) {
      onVideoStatus(videoPosition);
      setVideoLoading(false);
      dispatch(updateOnBoardingSettings('videoPlaying', false))
      setPlaying(false);
      typeof videoPosition === 'number' && playerRef?.current?.seekTo(0.999)
    } else {
      onVideoStatus(videoPosition);
      setVideoLoading(false);
      typeof videoPosition === 'number' && playerRef?.current?.seekTo(videoPosition)
    }

  }, [clickedPillsTime, videoPopIn, stimulus?.play_url && duration])

  const handlePlayPause = () => {
    setPlaying(!playing);
    dispatch(updateOnBoardingSettings('videoPlaying', !playing))
  }

  const handlePlay = () => {
    setEnded(false);
    setPlaying(true);
    dispatch(updateOnBoardingSettings('videoPlaying', true))
    onVideoPlay();
  };

  const handlePause = () => {
    setPlaying(false)
    dispatch(updateOnBoardingSettings('videoPlaying', false))
  }

  const handleProgress = (state: any) => {
    if (!seeking && checkValid(state.playedSeconds) && !ended && state.played !== 0.999 && state.played !== 0) {
      onVideoStatus(state.played);
    }
  }

  const checkValid = (second: number) => {
    let isValid = true;
    if (second < videoStart) {
      seekToStart();
      onVideoStatus(videoStart / duration);
      isValid = false;
    } else if (second > videoEnd) {
      onVideoStatus(videoStart / duration);
      onEnd();
      isValid = false;
    } else if (second >= graphLength + videoStart + 0.6) {
      onVideoStatus(graphLength / duration);
      dispatch(updateOnBoardingSettings('videoPlaying', false))

      setPlaying(false);
      setEnded(true);
      isValid = false;
    }
    return isValid;
  }

  const getVideoPlayed = (played: number) => {
    return (played * duration - videoStart) / Math.max(1, (videoEnd - videoStart));
  }

  const onVideoStatus = (value: number) => {
    setPlayed(getVideoPlayed(value));
    dispatch(updateOnBoardingSettings('videoPlayed', value))
    if (videoSkip) {
      dispatch(updateOnBoardingSettings('videoSkip', false))
    } else {
      dispatch(updateOnBoardingSettings('videoStopped', false))
    }
    if (getVideoPlayed(value) < 0.0001 || getVideoPlayed(value) >= 0.9999) {
      dispatch(updateOnBoardingSettings('videoStopped', true))
    }
  };

  const seekToStart = () => {
    playerRef?.current?.seekTo(videoStart);
  };

  const onReady = () => { setVideoReady(true) }
  const onStart = () => { }
  const onSeek = () => {
    setVideoLoading(false);
  };

  const handleDuration = (duration: any) => {
    if (!stimulus?.stimulus_video_length) {
      // dispatch(addVideoLength(duration))
    }
    setPlaying(false);
    dispatch(updateOnBoardingSettings('videoPlaying', false));
    setDuration(duration)
  };

  const onEnd = () => {
    dispatch(updateOnBoardingSettings('videoPlaying', false))
    setPlaying(false);
    setEnded(true);
    if (playerRef && playerRef.current) {
      playerRef?.current?.seekTo(videoStart);
      setPlayed(getVideoPlayed(0));
    }

    dispatch(updateOnBoardingSettings('videoSkip', true))
    dispatch(updateOnBoardingSettings('videoStopped', true))
    dispatch(updateOnBoardingSettings('videoPlayed', 0))

  };

  const handleClickFullscreen = () => {
    if (screenfull.isEnabled) {
      screenfull.request(playerRef?.current?.wrapper);
    }
  };

  const handleSliderChange = (_event: any, newValue: number | number[]) => {
    const seconds = getSeconds(newValue);
    if (checkValid(seconds)) {
      onVideoStatus(seconds / duration)
      if (popOut) {
        setVideoLoading(true);
        popOut(Math.floor(seconds) - videoStart);
      }
    } else {
      onVideoStatus(graphLength / duration);
      setEnded(true);
    }
  };

  const handleSliderCommitted = (_event: any, value: number | number[]) => {
    setSeeking(false);
    const seconds = getSeconds(value);
    if (checkValid(seconds))
      playerRef?.current?.seekTo(seconds)
  };

  const getSeconds = (value: any) => {
    return (value / 100) * Math.max(1, videoEnd - videoStart) + videoStart;
  };

  return (
    <div
      className={classes.root}
      style={{ marginTop: mt, marginBottom: mb, position: position ? position : 'static' }}
    >
      <div
        className={classes.container}
        style={{
          width: isMobile ? '40vw' : width,
          height: isMobile ? 'auto' : height,
          border: isMobile ? 'none' : '5px solid #FFFFFF'
        }}
        onMouseEnter={() => !isMobile && setHoverState(true)}
        onMouseLeave={() => !isMobile && setHoverState(false)}
      >
        {
          (hoverState && videoReady && !isMobile) &&
          <div className={classes.playback} onClick={handlePlayPause}>
            <img
              src={`/assets/icons/liveanalysis/${(playing && played !== 1) ? 'pause' : 'play'}-button.svg`}
              alt={'icon'}
              className={classes.playbackIcon}
            />

          </div>
        }

        {
          stimulus?.play_url && videoLoading &&
          <div className={classes.playback}>
            <VideoLoading />
          </div>
        }

        <img
          src={img ? img : `${apiConfigs.S3_IMG_URL}/small-55.svg`}
          className={classes.video}
          style={{
            display: (!played || played >= 0.999 || played === 0) ? 'block' : 'none',
            width: isMobile ? '40vw' : (width - 10),
            height: isMobile ? 'auto' : (height - 10)
          }}
          alt={''}
        />
        <div
          className={classes.box}
          style={{ display: (!played || played >= 0.999 || played === 0) ? 'none' : 'block' }}
        >
          <ReactPlayer
            width={isMobile ? '40vw' : width}
            height={isMobile ? 'auto' : height}
            url={video}
            ref={playerRef}
            playing={playing}
            onReady={onReady}
            onStart={onStart}
            onPlay={handlePlay}
            onPause={handlePause}
            onSeek={onSeek}
            onEnded={() => setTimeout(() => onEnd(), 2000)}
            onError={() => {}}
            onProgress={handleProgress}
            onDuration={handleDuration}
            className={classes.player}
            vimeoconfig={{ iframeParams: { fullscreen: 0 } }}
            config={{
              youtube: {
                playerVars: {
                  modestbranding: 1,
                  disablekb: 1,
                  showinfo: 0,
                  autohide: 2,
                  theme: 'dark',
                  start: videoStart,
                  end: videoEnd,
                  rel: 0,
                  ecver: 2
                }
              }
            }}
          />
        </div>

        {
          stimulus?.stimulus_video_length && videoReady &&
          <div className={classes.control}>
            <img
              onClick={handlePlayPause}
              src={`/assets/icons/liveanalysis/${(playing && played !== 1) ? 'resume' : 'play'}_btn.svg`}
              alt={'icon'}
              className={classes.playBtn}
            />

            <PrettoSlider
              aria-label="pretto slider"
              min={0}
              max={100}
              value={played * 100}
              onChange={handleSliderChange}
              onChangeCommitted={handleSliderCommitted}
              className={classes.progress}
              style={{ width: isMobile ? '22vw' : (width - 80) }}
            />

            <img
              onClick={handleClickFullscreen}
              src={'/assets/icons/liveanalysis/scale_btn.svg'}
              alt={'icon'}
              className={classes.playBtn}
              style={{ height: 11, marginLeft: -5 }}
            />
          </div>
        }

      </div>
    </div>
  );
}

export default VideoSection;